<template>
  <!-- Boerenbridge neemt het scherm over zodra er een spel van loopt -->
  <template v-if="bbView">
    <BbPlayerSetup v-if="bbView === 'setup'" />
    <BbDealerSelect v-else-if="bbView === 'dealer'" />
    <BbBidding v-else-if="bbView === 'bidding'" />
    <BbBidOverview v-else-if="bbView === 'overview'" />
    <BbResult v-else-if="bbView === 'result'" />
    <BbScoreboard v-else />
  </template>
  <template v-else>
    <StartGame v-if="view === 'start'" />
    <PlayerSetup v-else-if="view === 'setup'" />
    <DealerSelect v-else-if="view === 'dealer'" />
    <Scoreboard v-else-if="view === 'scoreboard'" />
    <SelectContract v-else-if="view === 'round'" />
    <GameIsOn v-else-if="view === 'playing'" />
    <EnterResult v-else-if="view === 'result'" />
  </template>

  <ConfirmDialog
    v-if="bbConfirmingEndGame"
    title="Spel beëindigen?"
    body="Alle voortgang gaat verloren. Dit kan niet ongedaan worden gemaakt."
    confirm-label="Spel beëindigen"
    @confirm="bbEndGame"
    @cancel="bbCancelEndGame"
  />

  <div v-if="confirmingEndGame" class="confirm-overlay" @click.self="cancelEndGame">
    <div class="confirm-dialog">
      <p class="confirm-title">Spel beëindigen?</p>
      <p class="confirm-body">Alle voortgang gaat verloren. Dit kan niet ongedaan worden gemaakt.</p>
      <div class="confirm-actions">
        <button class="confirm-btn cancel" @click="cancelEndGame">Annuleren</button>
        <button class="confirm-btn end" @click="endGame">Spel beëindigen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useGameStore } from './stores/game'
import { useBoerenbridgeStore } from './stores/boerenbridge'
import StartGame from './components/setup/StartGame.vue'
import PlayerSetup from './components/setup/PlayerSetup.vue'
import DealerSelect from './components/setup/DealerSelect.vue'
import Scoreboard from './components/scoring/Scoreboard.vue'
import SelectContract from './components/contract/SelectContract.vue'
import GameIsOn from './components/playing/GameIsOn.vue'
import EnterResult from './components/result/EnterResult.vue'
import BbPlayerSetup from './components/boerenbridge/BbPlayerSetup.vue'
import BbDealerSelect from './components/boerenbridge/BbDealerSelect.vue'
import BbBidding from './components/boerenbridge/BbBidding.vue'
import BbBidOverview from './components/boerenbridge/BbBidOverview.vue'
import BbResult from './components/boerenbridge/BbResult.vue'
import BbScoreboard from './components/boerenbridge/BbScoreboard.vue'
import ConfirmDialog from './components/shared/ConfirmDialog.vue'

export default {
  name: 'App',
  components: {
    StartGame,
    PlayerSetup,
    DealerSelect,
    Scoreboard,
    SelectContract,
    GameIsOn,
    EnterResult,
    BbPlayerSetup,
    BbDealerSelect,
    BbBidding,
    BbBidOverview,
    BbResult,
    BbScoreboard,
    ConfirmDialog
  },
  computed: {
    ...mapState(useGameStore, ['view', 'confirmingEndGame']),
    ...mapState(useBoerenbridgeStore, {
      bbView: 'view',
      bbConfirmingEndGame: 'confirmingEndGame'
    })
  },
  methods: {
    ...mapActions(useGameStore, ['cancelEndGame', 'endGame']),
    ...mapActions(useBoerenbridgeStore, {
      bbCancelEndGame: 'cancelEndGame',
      bbEndGame: 'endGame'
    })
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  height: 100vh;
  height: 100dvh;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  background-color: #d4e9d4;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  background-color: #d4e9d4;
}

.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 100;
}

.confirm-dialog {
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.confirm-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2c3e50;
}

.confirm-body {
  font-size: 0.95rem;
  color: #555;
}

.confirm-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.confirm-btn {
  flex: 1;
  padding: 0.85rem;
  font-size: 1rem;
  font-family: inherit;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
  border: none;
}

.confirm-btn.cancel {
  background: transparent;
  color: #2c3e50;
  border: 2px solid #2c3e50;
}

.confirm-btn.end {
  background-color: #c0392b;
  color: #fff;
}

.confirm-btn:active {
  opacity: 0.75;
}
</style>
